module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-menu-panel"
  }, [_c('div', {
    staticClass: "lxm-menu-panel__background",
    on: {
      "click": _vm.backgroundClicked
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lxm-menu-panel__triangle",
    attrs: {
      "src": require("../../images/main/dashboard/triangle.png")
    }
  }), _vm._v(" "), _c('lxm-panel', {
    staticClass: "lxm-menu-panel__panel",
    attrs: {
      "rows": _vm.rows,
      "panelStyle": {
        padding: ("0 " + (50 / 2 / 14) + "rem 0 " + (55 / 2 / 14) + "rem")
      },
      "panelBlockStyle": {}
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ad6d798", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ad6d798!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmMenuPanel.vue
// module id = 829
// module chunks = 0